import * as yup from 'yup';
import _map from 'lodash/map';
import { EMPTY_ARRAY, Row, RenderConfig, Column, TextInput, SelectInput, CASE } from 'commons-ui';

import { PAGE_NAMES } from 'constant';

import { APP_OPTIONS, APP_ACTIONS, DASHBOARD_ENTITY_OPTIONS, FORM_FIELD_KEYS, KEY_NAME_MAP } from './constants';
import {
	getSiblingDependencies,
	appRoleDependencyResolver,
	actionsDependencyResolver,
	onChangeConfigValAction
} from './formConfigHelper';

export const APP_LEVEL_ACTIONS = _map(Object.keys(APP_ACTIONS), (action) => ({
	id: APP_ACTIONS[action],
	label: APP_ACTIONS[action]
}));

export const validationSchema = yup.object().shape({
	role: yup
		.string()
		.test('len', 'Role is required', (val) => !val || val.length > 0)
		.required('Role is required')
});

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.ROLE),
	new Row(FORM_FIELD_KEYS.SETTINGS_CONFIG, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SETTINGS_ENTITY)]),
		new Column([new Row(FORM_FIELD_KEYS.SETTINGS_ACTIONS)])
	]),
	new Row(
		FORM_FIELD_KEYS.APP_ENTITY_ACTION_CONFIG,
		EMPTY_ARRAY,
		[],
		[
			new Row(null, EMPTY_ARRAY, [
				new Column([new Row(FORM_FIELD_KEYS.APP)]),
				new Column([new Row(FORM_FIELD_KEYS.APP_LEVEL_ACTION)])
			]),
			new Row(FORM_FIELD_KEYS.DASHBOARD_CONFIG, EMPTY_ARRAY, [
				new Column([new Row(FORM_FIELD_KEYS.DASHBOARD_ENTITY)]),
				new Column([new Row(FORM_FIELD_KEYS.DASHBOARD_ACTIONS)])
			]),
			new Row(FORM_FIELD_KEYS.GAME_ADMIN_CONFIG, EMPTY_ARRAY, [
				new Column([new Row(FORM_FIELD_KEYS.GAME_ADMIN_ENTITY)]),
				new Column([new Row(FORM_FIELD_KEYS.GAME_ADMIN_ACTIONS)])
			])
		]
	)
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.ROLE]: new RenderConfig()
		.setName(KEY_NAME_MAP.ROLE)
		.setLabel('Role')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true, letterCase: CASE.UPPERCASE }),
	[FORM_FIELD_KEYS.APP]: new RenderConfig()
		.setName(KEY_NAME_MAP.APP)
		.setLabel('App')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: false, edit: false },
			options: APP_OPTIONS
		}),
	[FORM_FIELD_KEYS.APP_ENTITY_ACTION_CONFIG]: new RenderConfig()
		.setName(KEY_NAME_MAP.APP_ENTITY_ACTION_CONFIG)
		.setLabel('Role Config')
		.setRenderProps({
			isArrayField: true,
			isEditable: { create: false, edit: false }
		}),
	[FORM_FIELD_KEYS.DASHBOARD_ENTITY]: new RenderConfig()
		.setName(KEY_NAME_MAP.DASHBOARD_ENTITY)
		.setLabel('Dashboard Entity')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false }
		}),
	[FORM_FIELD_KEYS.DASHBOARD_ACTIONS]: new RenderConfig()
		.setName(KEY_NAME_MAP.DASHBOARD_ACTIONS)
		.setLabel('Dashboard Actions')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			multi: true,
			options: [],
			getDependencies: getSiblingDependencies(KEY_NAME_MAP.DASHBOARD_ENTITY),
			dependencyResolver: actionsDependencyResolver(PAGE_NAMES.dashboard),
			onChangeCallback: onChangeConfigValAction
		}),

	[FORM_FIELD_KEYS.DASHBOARD_CONFIG]: new RenderConfig()
		.setName(KEY_NAME_MAP.DASHBOARD_CONFIG)
		.setLabel('Dashboard Config')
		.setIsCollapsible(true)
		.setRenderProps({
			isArrayField: true,
			isEditable: { create: false, edit: false },
			getDependencies: getSiblingDependencies(KEY_NAME_MAP.APP_LEVEL_ACTION),
			maxLength: DASHBOARD_ENTITY_OPTIONS.length,
			minLength: DASHBOARD_ENTITY_OPTIONS.length,
			dependencyResolver: appRoleDependencyResolver
		}),
	[FORM_FIELD_KEYS.SETTINGS_CONFIG]: new RenderConfig()
		.setName(KEY_NAME_MAP.SETTINGS_CONFIG)
		.setLabel('Settings Config')
		.setRenderProps({
			isArrayField: true,
			isEditable: { create: false, edit: false }
		}),

	[FORM_FIELD_KEYS.SETTINGS_ENTITY]: new RenderConfig()
		.setName(KEY_NAME_MAP.SETTINGS_ENTITY)
		.setLabel('Settings Entity')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false }
		}),
	[FORM_FIELD_KEYS.SETTINGS_ACTIONS]: new RenderConfig()
		.setName(KEY_NAME_MAP.SETTINGS_ACTIONS)
		.setLabel('Settings Actions')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			multi: true,
			options: [],
			getDependencies: getSiblingDependencies(KEY_NAME_MAP.SETTINGS_ENTITY),
			dependencyResolver: actionsDependencyResolver(PAGE_NAMES.settings)
		}),
	[FORM_FIELD_KEYS.GAME_ADMIN_CONFIG]: new RenderConfig()
		.setName(KEY_NAME_MAP.GAME_ADMIN_CONFIG)
		.setLabel('Game Admin Config')
		.setRenderProps({
			isArrayField: true,
			isEditable: { create: false, edit: false }
		}),

	[FORM_FIELD_KEYS.GAME_ADMIN_ENTITY]: new RenderConfig()
		.setName(KEY_NAME_MAP.GAME_ADMIN_ENTITY)
		.setLabel('Game Admin Entity')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: false, edit: false }
		}),
	[FORM_FIELD_KEYS.GAME_ADMIN_ACTIONS]: new RenderConfig()
		.setName(KEY_NAME_MAP.GAME_ADMIN_ACTIONS)
		.setLabel('Game Admin Actions')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			multi: true,
			options: [],
			getDependencies: getSiblingDependencies(KEY_NAME_MAP.GAME_ADMIN_ENTITY),
			dependencyResolver: actionsDependencyResolver(PAGE_NAMES.gameAdmin)
		}),
	[FORM_FIELD_KEYS.APP_LEVEL_ACTION]: new RenderConfig()
		.setName(KEY_NAME_MAP.APP_LEVEL_ACTION)
		.setLabel('Action')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: APP_LEVEL_ACTIONS
		})
};
